import { defineComponent as _defineComponent } from 'vue'
import HomeTestimonyCarousel from './HomeTestimonyCarousel.vue';
  import AppChimp from './AppChimp.vue';
  import { ref } from 'vue';
  import IconArrowLiteRight from '@/icons/icon-arrow-lite-right.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'HomeTestimony',
  setup(__props, { expose: __expose }) {
  __expose();

  const showSlider = ref(true);
  const moveSlide = () => {
    showSlider.value = !showSlider.value;
  };

const __returned__ = { showSlider, moveSlide, HomeTestimonyCarousel, AppChimp, ref, IconArrowLiteRight }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})